import { useEffect, useState } from 'react'

import adminCss from './sass/adminpage.module.scss'
import { areAllChargesPaid, auctionDetailsComplete, auctionHasItems } from './auctionsadminutil'

export default function PreviewPublishChecklist(props) {

  const [checkMessage, setCheckMessage] = useState('')
  const [checkList, setCheckList] = useState([])
  const [itemStatus, setItemStatus] = useState([false])

  const greenCheck = <p className={adminCss['greencheck']}>✔</p>
  const redX = <p className={adminCss['redx']}>𐄂</p>
  
  useEffect(() => {    
    const auctionItemCheck = () => {
      if (!props.auctionDetail) return
      const detailsComplete = auctionDetailsComplete(props.auctionDetail)
      const hasItems = auctionHasItems(props.auctionDetail)
      return [detailsComplete, hasItems]
    }

    if (!props.auctionDetail) return

    if (props.liveStatus === 'ended' && props.auctionDetail.Status !== 'PREVIEW' ) {
      setCheckMessage('Auction Complete Checklist:')
      setCheckList(['All charges paid'])
      setItemStatus([areAllChargesPaid(props.auctionDetail)])
    } else {
      setCheckMessage('Auction Ready Checklist:')
      setCheckList(['Auction Details Complete', 'Auction Has Items'])
      setItemStatus(auctionItemCheck())
    }
    
  }, [props.liveStatus, props.auctionDetail])

  if (!props.auctionDetail) return <></>

  return (
    <div className={adminCss[`widget-checklist-${props.location}`]}>
      <p className={adminCss['widget-checklist-header']}>
        {checkMessage}
      </p>
      {checkList?.map((item, idx) => <li key={`${item}-${idx}`}
                                      className={adminCss[`widget-checklist-${props.location}-item`]}>
                                        <span>{itemStatus[idx] ? greenCheck : redX}</span>
                                          {item}
                                    </li>)}
      <p className={adminCss['widget-checklist-header']}>
        <a target="_blank" rel="noreferrer"
           href="https://ucla.box.com/shared/static/tq48kz9143x4bric4jb4d7m5q3l10ywr.pdf">Download admin manual from Box</a>
      </p>
    </div>
  )
}